import { render, staticRenderFns } from "./CouponAlternate.vue?vue&type=template&id=6ecdeee2&"
import script from "./CouponAlternate.vue?vue&type=script&lang=js&"
export * from "./CouponAlternate.vue?vue&type=script&lang=js&"
import style0 from "./CouponAlternate.vue?vue&type=style&index=0&id=6ecdeee2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports